import React from 'react';
import { FilterCard } from './FilterCard.js';
import { VerticalContainer } from './FlexboxContainer.js';
import { combineClassNames } from '../util/css/classNames.js';
import styles from './FilterCardList.scss';
export const FilterCardList = ({ className, filters, expandedFilters, activeFilters, onFilterSelected, onFilterExpanded, }) => (React.createElement(VerticalContainer, { contentAlign: "center", wrap: false, className: combineClassNames(styles.filterContainer, className) }, filters &&
    filters.map((filter, i) => (React.createElement(FilterCard, { key: filter.categoryName, selectedFilter: activeFilters[i], selectFilter: onFilterSelected, filter: filter, extend: () => {
            onFilterExpanded(i);
        }, extended: expandedFilters[i] })))));
